module.exports = __webpack_public_path__ + "img/ds.809e56e0.png";